import { deburr } from 'lodash';

const isCleanedRegex = /^[a-z0-9-_]+$/;

export const cleanUtils = {
  clean: (str: string): string =>
    deburr(`${str.trim()}`)
      .toLowerCase()
      .replace(/[^a-z0-9-_]/g, '_'),
  isCleaned: (cleanedFullName: string): boolean => isCleanedRegex.test(cleanedFullName),
} as const;

export const getActiveGroupIds = (visibleGroupsIds: string[], filterGroups?: string) => {
  if (!filterGroups) return visibleGroupsIds;
  const relevantActiveGroupIds = filterGroups.split(',').filter((id) => visibleGroupsIds.includes(id));
  if (relevantActiveGroupIds.length > 0) return relevantActiveGroupIds;
  return visibleGroupsIds;
};
